import React, { useRef, useState, Fragment, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog, Transition } from '@headlessui/react'

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//E-Posta Check
import emailValidator from 'email-validator'

//ICONS
import { BsShieldExclamation, BsQrCode } from "react-icons/bs";

//API
import { ogrenciRegister, createCode, verifyCode } from '../../../apis/ogrenci';


const RegisterSave = () => {

    const location = useLocation()
    const navigate = useNavigate()

    //console.log(location.state)

    //Refs
    const cancelButtonRef = useRef(null) //For Modal

    const telefonRef = useRef()
    const epostaRef = useRef()
    const sifreRef = useRef()
    const sifreTekrarRef = useRef()
    const codeRef = useRef()

    //*******************************************STATES 
    const [open, setOpen] = useState(false) // Modal
    const [startCountdown, setStartCountdown] = useState(false);
    const [countdown, setCountdown] = useState(0);


    const [telefon, setTelefon] = useState("")
    const [eposta, setEposta] = useState("")
    const [sifre, setSifre] = useState("")
    const [sifreTekrar, setSifreTekrar] = useState("")
    const [code, setCode] = useState("")
    const [codeError, setCodeError] = useState("")





    //********************************************HANDEL FUNCTIONS

    function checkPasswordRequirements(password) {
        // Büyük harf kontrolü
        const hasUpperCase = /[A-Z]/.test(password);
        // Rakam kontrolü
        const hasNumber = /\d/.test(password);
        // Simge kontrolü - Burada istediğiniz simgeleri ekleyebilirsiniz
        //eslint-disable-next-line
        const hasSymbol = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password);

        // Tüm koşulların sağlanıp sağlanmadığını kontrol et
        const isPasswordValid = hasUpperCase && hasNumber && hasSymbol;

        return isPasswordValid;
    }

    const handleTelefonControl = (e) => {
        const re = /^\d{0,10}$/;
        if (e === "" || re.test(e)) {
            setTelefon(e);
        }
    }

    const handleFormControl = () => {
        if (telefon === "") {
            telefonRef.current.focus()
            return toast.error("Lütfen telefon numaranızı giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }
        const emailChecking = emailValidator.validate(eposta)
        if (eposta === "" || emailChecking === false) {
            epostaRef.current.focus()
            return toast.error("Lütfen gerçerli bir e-posta adresi giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }
        const sifrekontrol = checkPasswordRequirements(sifre)
        if (!sifrekontrol) {
            sifreRef.current.focus()
            return toast.error("Şifreniz içeriğinde enaz 1 büyük harf, rakam ve özel karakter olmalıdır!", {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        if (sifre === "") {
            sifreRef.current.focus()
            return toast.error("Lütfen şifre giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }

        if (sifre === "") {
            sifreTekrar.current.focus()
            return toast.error("Lütfen şifrenizi tekrar giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }

        if (sifre !== sifreTekrar) {
            sifreRef.current.focus()
            return toast.error("Şifreniz uyuşmamaktadır.", {
                position: toast.POSITION.TOP_LEFT
            });
        }


        //setOpen(true)
        handleCreateCode()
    }
    const handleCreateCode = async () => {

        let result = await createCode({ phoneNumber: telefon, ogrenciEposta : eposta, temporyToken : location.state.temporyToken })
        if (result.status === 200) {
            toast.success(result.data.message, {
                position: toast.POSITION.TOP_LEFT
            });
            setOpen(true)
            setStartCountdown(true);
            setCountdown(80);
            setCodeError("")
            setCode("")
        } else {
            return toast.warning(result.response.data, {
                position: toast.POSITION.TOP_LEFT
            });
        }
    }


    const handleCodeDogrula = async () => {

        // Gönderilen kodun süresi dolmnuş mu?
        //Geçerli bir doğrulama kodu ise kodu sorgula


        let result = await verifyCode({ phoneNumber: telefon, code: code, temporyToken : location.state.temporyToken })
        if (result.status === 200) {
            toast.success("Bilgileriniz doğrulanıyor.", {
                position: toast.POSITION.TOP_LEFT
            });
            setStartCountdown(false)
            setOpen(false)
            handleOgrenciRegister()
        } else {
            if (result.response.data.errorCode === 2) {
                setCodeError(result.response.data.message)
                setCode("")
            }

            if (result.response.data.errorCode === 1) {
                setCodeError(result.response.data.message)
                setCode("")
                setCountdown(0);
            }

        }
    }

    const handleOgrenciRegister = async () => {

        let data = {
            tcNo: location.state.tc,
            ogrenciNo: location.state.OgrenciNo,
            ogrenciAdiSoyadi: location.state.adSoyad,
            ogrenciCepNo: telefon,
            ogrenciEposta: eposta,
            ogrenciPassword: sifre,
            temporyToken : location.state.temporyToken
        }

        let result = await ogrenciRegister(data)
        if (result.status === 200) {
            toast.success("Kaydınız yapıldı. Yönelendiriliyorsunuz.", {
                position: toast.POSITION.TOP_LEFT
            });

            const waitTime = 3000;
            const wait = (time) => new Promise(resolve => setTimeout(resolve, time));
            wait(waitTime).then(() => {
                navigate('/login');
            });
        }else{
            return toast.error("Girmiş olduğunuz bilgiler sistemde mevcuttur.", {
                position: toast.POSITION.TOP_LEFT
            });
        }
    }



    useEffect(() => {
        if (startCountdown) {
            const interval = setInterval(() => {
                if (countdown === 0) {
                    setStartCountdown(false);
                    toast.error("Belirtilen süre içerisinde kodu girmediniz. Lütfen tekrar kod isteyiniz", {
                        position: toast.POSITION.TOP_LEFT
                    });
                } else {
                    setCountdown(countdown - 1);
                }
            }, 1000);
            return () => clearInterval(interval);
        }
        // eslint-disable-next-line
    }, [countdown, startCountdown]);

    return (
        <>
            <ToastContainer />
            <div className='relative mx-auto w-full max-w-sm bg-white'>
                <div>
                    <img src={process.env.PUBLIC_URL + '/images/odu-yatay-color.png'} alt='Ordu Üniversitesi' className='h-16' />
                    <h2 className="text-2xl font-semibold  leading-6 mt-6 mb-2 text-slate-600"> Merhaba, </h2>
                    <p className="leading-6 text-sm text-slate-500 mb-6"> <strong>{process.env.REACT_APP_PROJECT_LOWER_NAME}</strong> Öğrenci Kayıt Ekranı</p>
                </div>
                <div className='mt-5'>
                    <div className='space-y-2'>
                        <div>
                            <div className="flex w-full overflow-hidden bg-white rounded-md border mb-6">
                                <div className="flex items-center justify-center w-16 bg-red-500">
                                    <BsShieldExclamation className='text-2xl text-white' />
                                </div>

                                <div className="px-4 py-2 -mx-3">
                                    <div className="mx-3">
                                        <span className="font-semibold text-slate-600">Sayın, {location?.state?.adSoyad}</span>
                                        <p className="text-sm text-slate-600">
                                            Kayıt işleminizin tamamlanması için lütfen aşağıda istenilen bilgileri giriniz.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>Cep telefon numaranız</label>
                            </div>
                            <div>
                                <div>
                                    <input value={telefon} ref={telefonRef} onChange={(e) => { handleTelefonControl(e.target.value) }} type='tel' placeholder='5XX XXX XXXX' className='sd-input' />
                                </div>
                            </div>
                        </div>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>E-Posta adresiniz</label>
                            </div>
                            <div>
                                <div>
                                    <input ref={epostaRef} onChange={(e) => setEposta(e.target.value)} type='phone' placeholder='@posta' className='sd-input' />
                                </div>
                            </div>
                        </div>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>Şifre</label>
                            </div>
                            <div>
                                <div>
                                    <input ref={sifreRef} onChange={(e) => setSifre(e.target.value)} type='password' placeholder='***' className='sd-input' />
                                    <p className='text-xs text-right text-slate-400'>Güvenli şifre oluşturma için <a className='text-emerald-500 hover:text-emerald-700' href='https://rastgelesifre.odu.edu.tr/' target='blank'>tıklayınız</a></p>
                                </div>
                            </div>
                        </div>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>Tekrar Şifre</label>
                            </div>
                            <div>
                                <div>
                                    <input ref={sifreTekrarRef} onChange={(e) => setSifreTekrar(e.target.value)} type='password' placeholder='***' className='sd-input' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-6'>
                        <button onClick={() => handleFormControl()} className='text-white bg-slate-600 hover:bg-slate-600/80 h-12 leading-5 px-4 py-1 w-full rounded-md border border-slate-300 focus:outline-slate-300 focus:outline-offset-2 focus:outline-dashed focus:outline-1 transition-all duration-150'>KAYDET</button>
                    </div>
                    <div className='w-full mt-8 text-sm text-slate-400 text-center'>Bilgi İşlem Daire Başkanlığı {new Date().getFullYear()}</div>
                </div>
            </div>
            {/* E-PIN MODAL */}
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={() => setOpen(true)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div>
                                        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                                            <BsQrCode className="h-6 w-6 text-green-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:mt-5">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-slate-600">
                                                Doğrulama Kodu
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <input value={code} ref={codeRef} onChange={e => setCode(e.target.value)} className='border w-[50%] tracking-widest h-10 rounded text-center text-lg text-slate-600 outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' type='text' />
                                            </div>
                                            <div className="mt-2">
                                                {
                                                    codeError !== "" ? (
                                                        <p className='text-red-600 text-sm'>
                                                            {codeError}
                                                        </p>
                                                    ) : null
                                                }

                                                <p className="text-sm text-slate-500">
                                                    Lütfen belirtilen süre içerisinde gönderilen doğrulama kodunu giriniz
                                                </p>
                                                <p className="text-sm text-slate-500">
                                                    Kalan süre : <span className='font-semibold'>{countdown}</span> saniye
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-slate-600 disabled:bg-slate-300 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2  sm:col-start-2"
                                            onClick={() => handleCodeDogrula()}
                                            disabled={code === "" ? true : false}
                                        >
                                            Onayla
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full border justify-center rounded-md bg-slate-100 px-3 py-2 text-sm font-semibold text-slate-600 disabled:text-slate-300 disabled:hover:bg-slate-100 hover:bg-slate-200 sm:col-start-1 sm:mt-0"
                                            onClick={() => handleCreateCode()}
                                            ref={cancelButtonRef}
                                            disabled={countdown === 0 ? false : true}
                                        >
                                            Tekrar gönder
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
}

export default RegisterSave;
